import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapCohortOptions = (
  option: UCM.CohortOptionRawType,
): UCM.CohortOptionType => ({
  value: option.code,
  label: option.name,
});

const getCohortOptions = async () => {
  const { data } = await getRequest<RequestDataArray<UCM.CohortOptionRawType>>(
    API.GET.cohortOptions,
  );
  return data.data.map(({ attributes }) => mapCohortOptions(attributes));
};

export const useGetCohortOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.COHORT_OPTIONS],
    queryFn: getCohortOptions,
    staleTime: 1000 * 60 * 5,
    ...config,
  });
};
